
import Dish from '@/shared/dish/ui/Dish.vue';
import Component, { mixins } from 'vue-class-component';

@Component
export default class ItecDish extends mixins(Dish) {}
